/** @format */

import update from 'immutability-helper';
import {parseEntityError} from 'frontier-form';
import React from 'react';
import SuperAgent from 'superagent';
import {CartCheckoutContext} from 'frontier/cart/components/cart/cart_checkout_context';

export default function withDiscountHandler(ComponentContainer) {
    return class extends React.Component {
        static contextType = CartCheckoutContext;
        static propTypes = {};

        constructor(props) {
            super(props);
            this.state = {
                error: false,
                pending: false,
                done: false,
                discount_code: props.discount_code || '',
                discount_label: props.discount_label || '',
                discount_id: props.discount_id || '',
                discount_amount: props.discount_amount || ''
            };
        }

        handleChange = updateTarget => {
            this.setState(update(this.state, updateTarget));
        };

        handleCheckCode = () => {
            this.setState({pending: true});
            SuperAgent.post('/carts/save-discount')
                .set('Accept', 'application/json')
                .send({discount_code: this.state.discount_code})
                .end((err, response) => {
                    if (err || !response.body) {
                        this.setState({error: parseEntityError(response.body), pending: false});
                    } else {
                        const {discount_id, discount_amount, discount_label} = response.body;
                        this.setState({
                            pending: false,
                            done: true,
                            discount_id: discount_id,
                            discount_amount: discount_amount,
                            discount_label: discount_label
                        });

                        const cartUpdateTarget = {};
                        cartUpdateTarget.cart = {
                            discount_id: {$set: discount_id},
                            discount_amount: {$set: discount_amount},
                            discount_label: {$set: discount_label}
                        };
                        this.context.onChange(cartUpdateTarget);
                    }
                });
        };

        handleClearDiscountId = () => {
            this.setState({discount_id: ''});
            this.setState({done: false});
        };

        handleRemoveDiscountId = () => {
            this.setState({discount_id: '', discount_amount: '', discount_code: ''});
            const cartUpdateTarget = {};
            cartUpdateTarget.cart = {
                discount_id: {$set: null},
                discount_amount: {$set: 0},
                discount_label: {$set: ''}
            };
            this.context.onChange(cartUpdateTarget);
        };

        render() {
            const props = {...this.props};
            props.onChange = this.handleChange;
            props.onCheckCode = this.handleCheckCode;
            props.onClearDiscountId = this.handleClearDiscountId;
            props.onRemoveDiscountId = this.handleRemoveDiscountId;

            return <ComponentContainer {...props} {...this.state} />;
        }
    };
}
